import React, { useEffect, useMemo, useRef, useState } from "react";
import { FileUploader } from "react-drag-drop-files";
import { AddToPhotos } from '@mui/icons-material';
import { ArrowBackIos, ArrowForwardIos, Close, Delete } from '@mui/icons-material';
import { Modal, IconButton } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';

import {Alert} from '@mui/material';
import COLOR from 'utils/constants/color';
import {Snackbar, TextField } from '@mui/material';

import styled from "styled-components";
import { Col, Row } from "antd";
import { find, findIndex, flatMap, get, map } from "lodash";
import { graphic_data } from "utils/constants/graphic_org";
import { useAllBook } from "store/books/selectors";
import { useResources } from "store/resources/selectors";
import { isVideo } from "utils/lib/ebookHelper";
import { IMAGE_FILE_TYPE } from "utils/constants/enum";
import SentryWrap from 'components/Sentry';
import { useOwnGraphicOrganizers } from "store/activities/selectors";

//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

const StyledTextField = muiStyled(TextField)(({ theme, hasBorder = true }) => ({
    '& .MuiInput-underline:before': {
        borderBottomColor: hasBorder ? 'black' : 'transparent',
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
        borderBottomColor: hasBorder ? 'black' : 'transparent',
    },
    '& .MuiInput-underline:after': {
        borderBottomColor: hasBorder ? 'black' : 'transparent',
    },
    '& .MuiInputBase-root': {
        padding: '2px',
        width: '100%'
    },
    '& .MuiInputBase-input': {
        fontSize: 16
    }
}));

const PlanWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: transparent;
  overflow: hidden;
`;

// const PlanContainer = styled.div`
//   display: flex;
//   flex-direction: column;
//   width: 90%;
//   height: 100%;
//   position: relative;
//   justify-content: center;
//   padding: 20px;
//   background-color: white;
//   justify-content: center;
//   align-items: center;
//   overflow: hidden;
// `;

const PlanContainer = styled.div`
  display: flex;
  flex-direction: column;
//   width: 90%;
  max-height: 100%;
  position: relative;
  justify-content: center;
  padding: 20px 100px;
  background-color: white;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  margin: 0px 20px;
  padding-left: 40px;
  padding-right: 40px;

  @media only screen and (max-width: 1400px) {
    overflow:auto;
    overflow-x: hidden;
  }
 @media only screen and (max-width: 991px) {
  display:unset;
  max-height: 96%;
  margin-bottom: 5%;
  width:85%;
   padding: 20px;
//    padding-bottom:45px;
 }
  @media only screen and (max-width: 500px) {
    width: 95%;
  }
`;

const CloseBtn = styled.div`
  background-color: rgb(204, 80, 71);
  border: none;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  position: absolute;
  top: 10px;
  right: 10px;
  color: white;
  z-index: 1;
`;

const Container = styled.div`
  display: flex;
`;

const PrintWrapper = styled.div`
  display: flex;
`;

const Images = styled.img`
 background-color: ${COLOR.white};
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
  object-fit: cover;
  height: 600px;
   height: 92vh;
    // max-height:100%;
    width:100%;

@media only screen and (max-width: 1500px) {
        height: 92vh;
        width: 100%;
}
`;

const ButtonContainer = styled.button`
  background-color: transparent;
  border: none;
  color: ${COLOR.black600};
  cursor: pointer;
  height: 40px;
  left: ${(p) => `${p.left}px`};
  outline: none;
  position: absolute;
  right: ${(p) => `${p.right}px`};
  top: 50%;
  transition: all 300ms ease;
  width: 40px;
  z-index: 1;
`;
const AnswerWindowWrapper = styled.div`
   position: relative;
   width: 100%;
`;
const FileUploadArea = styled.div`
    height: 100%;
    border: 1px dashed gray;
    padding: 5px 12px;
    min-height: 50px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    cursor: pointer;
`;

const ImageContainer = styled.div`
    height: auto;
    flex: 1;
`;
const Column = styled(Col)`
display: flex;
    justify-content: center;
    align-items: center;
}
`;
const Text = styled.div`
    font-size: 12px;
`;
const UploadedImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: contain;
    position: absolute;
    cursor: pointer;
    padding:10px;
`;
const ImageModal = styled.div`
    left: 50%;
    max-width: 544px;
    padding: 0px 24px;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
`;
const Image = styled.img`
    border: 1px solid ${COLOR.black800};
    width: 100%;
    height: auto;
`;
// function ImageUploader({  positions }) {
//     const [pagePoster, setpagePoster] = useState(null)
//     const max_height = positions.max_height ? { maxHeight: positions.max_height } : {};
//     const min_height = positions.min_height ? { minHeight: positions.min_height } : {};
//     return (
//         <ImageContainer onContextMenu={(e) => { }} style={{
//             position: 'absolute',
//             width: `calc(${positions.width} * 100%)`,
//             height: positions.height ? `calc(${positions.height} * 100%)` : '50px',
//             left: `calc(${positions.left} * 100%)`,
//             top: `calc(${positions.top} * 100%)`,
//             justifyContent: "center",
//             alignItems: 'center',
//             display: "flex",
//             ...max_height,
//             ...min_height
//         }}>
//              {pagePoster? <UploadedImage src={pagePoster}/>:null}
//                 <FileUploader
//                     handleChange={(file)=>{setpagePoster(URL.createObjectURL(file))}}
//                     name="file"
//                     types={fileTypes}

//                 >
//                 <FileUploadArea>
//                     <Row className="box box-1" style={{ display: "flex", gap: 4 }}>
//                         <Column >
//                             <AddToPhotos color="primary" />
//                         </Column>
//                         <Column>
//                             <Text>
//                                 Upload here
//                             </Text>
//                         </Column>
//                     </Row>
//                     <Row>
//                         <Text style={{ fontSize: 8 }}>
//                             {fileTypes.join(",")}
//                         </Text>
//                     </Row>

//                 </FileUploadArea>
//                 </FileUploader>
//         </ImageContainer>
//     )
// }

function ImageUploader({ positions,loaderImg }) {
    const [pagePoster, setpagePoster] = useState(null)
    const [modalOpen, setModalState] = useState(false)
    const handleDelete = () => {
        setpagePoster(null);
    };
    const max_height = positions.max_height ? { maxHeight: positions.max_height } : {};
    const min_height = positions.min_height ? { minHeight: positions.min_height } : { minHeight:"50px"};
    return (<>
        <Modal
            open={modalOpen}
            onClose={() => setModalState(false)}
            style={{ height: '100%', width: '100%' , zIndex:9999999999999}}
        >
            <ImageModal>
                <Image src={pagePoster} alt='' />
            </ImageModal>
        </Modal>
        <ImageContainer className={`${positions.class_name}`} onContextMenu={(e) => { }} style={{
            position: 'absolute',
            width: `calc(${positions.width} * 100%)`,
            height: positions.height ? `calc(${positions.height} * 100%)` : 'auto',
            left: `calc(${positions.left} * 100%)`,
            top: `calc(${positions.top} * 100%)`,
            ...max_height,
            ...min_height,
            justifyContent: "center",
            alignItems: 'center',
            display: "flex",
        }}>
            {pagePoster ? <>
                <UploadedImage onClick={() => setModalState(true)} src={pagePoster} />
                <IconButton color="secondary" style={{ position: "absolute", right: 6, top: -14 , zIndex:9999 , padding:0 }} onClick={handleDelete}
                ><Delete /></IconButton>
            </> :
                <FileUploader
                    handleChange={(file)=>{setpagePoster(URL.createObjectURL(file))}}
                    name="file"
                    types={IMAGE_FILE_TYPE}
                >
                    <FileUploadArea>
                        <Row className="box box-1" style={{ display: "flex", gap: 4 }}>
                            <Column >
                                <AddToPhotos color="primary" />
                            </Column>
                            <Column>
                                <Text>
                                    Upload here
                                </Text>
                            </Column>
                        </Row>
                        <Row>
                            <Text style={{ fontSize: 8 }}>
                                {IMAGE_FILE_TYPE.join(",")}
                            </Text>
                        </Row>

                    </FileUploadArea>
                </FileUploader>}
        </ImageContainer>
    </>)
}

const InputArea = ({ positions, value = "", isLabel = false }) => {
    const hasBorder = typeof positions.bottom_border === "boolean" ? positions.bottom_border : true;

    if (positions.input_type === "image") {
        return (<ImageUploader positions={positions} />)
    }
    const max_height = positions.max_height ? { maxHeight: positions.max_height } : {};
    const min_height = positions.min_height ? { minHeight: positions.min_height } : {};
    const height_value = positions.height ? { height: `calc(${positions.height} * 100%)` } : {};
    const width_value = positions.width ? { width: `calc(${positions.width} * 100%)` } : {};
    const top_value = positions.top ? { top: `calc(${positions.top} * 100%)` } : {};
    const paddingTop = positions.paddingTop ? { paddingTop: `calc(${positions.paddingTop} * 100%)` } : {};
    const left_value = positions.left ? { left: `calc(${positions.left} * 100%)` } : {};
    return (
        <StyledTextField
            className={`${positions.class_name} custom-scrollbar`}
            // multiline={positions.text_length === "multi_line"}
            multiline={true}
            style={{
                position: 'absolute',
                overflow: "auto",
                alignItems: 'center',
                ...max_height,
                ...min_height,
                ...height_value,
                ...width_value,
                ...top_value,
                ...left_value,
                ...paddingTop,
                backgroundColor: positions.background_color || "",
            }}
            placeholder={positions.placeholder || ''}
            label=""
            hasBorder={hasBorder}
            value={value}
            // cursor={value ? "default" : "text"}
            // pointerEvents={isLabel ? "none" : "none"}
            InputProps={{
                readOnly: !!value,               // 👈 disables editing and cursor blinking
              }}
        />
    );
};
const AnswerWindow = ({ src, input_position, label_position }) => {
    const [inputs] = useState(input_position || []);
    const [labelPosition] = useState(label_position || []);
    const allLocations = [...labelPosition.map(item => ({...item, source: 'label'})), {...inputs, source: 'input'}];
    
    return (
        <AnswerWindowWrapper className="inputAreaWrap">
            {/* {labelPosition.map((input, index) => (
                <InputArea key={index} positions={input} value={input.value} isLabel={true} />
            ))} */}
            <Images src={src} />
            {allLocations.map((input, value="", index) => (
                <InputArea key={index} positions={input} value={input?.value ? input.value : ""} isLabel={input.source === 'label'} />
            ))}
    
        </AnswerWindowWrapper>
    );
};
  

const GraphicAssignmentPreview = ({
    open,
    setOpen,
    assignment,
    page_id,
    bookId,
    graphicAssignmentData = {}
}) => {

    const backBtnRef = useRef(null);
    const forwardBtnRef = useRef(null);
    const booksAllList = useAllBook()
    const resources = useResources()
    const allresourcesVideo = flatMap(map(resources, k => k.videos))
    const [alertSakeBar, setAlertSakeBar] = useState({
        open: false,
        message: "",
        severity: "success",
    });
    const selected_book = useMemo(() => find(booksAllList, { id: bookId }), [booksAllList]);
    const select_book_pages = useMemo(() => get(selected_book, "pages", []), [selected_book]);
    const pageId = useMemo(() => get(assignment, "assignment_page"), [assignment])
    const ownGraphicOrganizer = useOwnGraphicOrganizers();

    const matchedObj = useMemo(() => {
        if (assignment?.copy_of?.id === '') return {};
        if (!assignment?.copy_of?.templateType && assignment?.copy_of?.templateType !== 'custom') return {};
        return find(ownGraphicOrganizer, (obj) => {
          return (
            obj.graphic_org_id === assignment?.copy_of?.id ||
            obj.graphic_org_id === graphicAssignmentData?.activityId ||
            obj.graphic_org_id === assignment?.id
          );
        });
      }, [ownGraphicOrganizer, assignment, open]);
      
    const input_position = useMemo(() => get(assignment, "input_position", []) || [], [assignment])
    const label_position = useMemo(() => get(matchedObj, "graphic_label", []) || [], [matchedObj])
    const currentPageResourse = useMemo(() => get(find(graphic_data, (obj) => obj.pageId == pageId), label_position?.length > 0 ? "edit_image_src" : "src"), [assignment])
    const [currentPageIndex, setCurrentPageIndex] = useState(0);
    const activePageResource = useMemo(() =>{
        if (isVideo(bookId, resources)) {
            const dataResource = find(allresourcesVideo, { id: page_id });
            return dataResource?.src;
        } else {
            return select_book_pages[currentPageIndex]?.resource
        }
    }, [currentPageIndex, select_book_pages]);

    function checkKey(e) {
        e = e || window.event;
        if (e.keyCode == '37') {
            if (backBtnRef.current && !backBtnRef.current.disabled) {
                backBtnRef.current.click()
            }

        }
        else if (e.keyCode == '39') {
            if (forwardBtnRef.current && !forwardBtnRef.current.disabled) {
                forwardBtnRef.current.click()
            }

        }

    }

    useEffect(() => {
        const index = findIndex(select_book_pages, (obj) => obj.pageId == page_id)
        setCurrentPageIndex(index);
    }, [select_book_pages, pageId])

    useEffect(() => {
        document.addEventListener('keydown', checkKey);
        return () => {
            document.removeEventListener("keydown", checkKey)
        }
    }, [])

    const closeAlert = () => {
        setAlertSakeBar({ open: false, message: "", severity: "success" });
    };

    const onPageChange = (direction) => {
        if (direction === "right" && currentPageIndex < select_book_pages.length - 1) {
            setCurrentPageIndex(currentPageIndex + 1);
        } else if (direction === "left" && currentPageIndex > 0) {
            setCurrentPageIndex(currentPageIndex - 1);
        }
    };
    return (
        <SentryWrap>
            <Snackbar
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                open={alertSakeBar.open}
                autoHideDuration={3000}
                onClose={closeAlert}
            >
                <Alert
                    onClose={() => {
                        setAlertSakeBar({ open: false, message: "" });
                    }}
                    severity={alertSakeBar.severity}
                >
                    <strong>ALERT:</strong> {alertSakeBar.message}
                </Alert>
            </Snackbar>
            <Modal
                open={open}
                onClose={() => setOpen(false)}
                className={"lessonPlanPopUp lessonPlanPopUpCstm"}
                style={{
                    height: "100%",
                    width: "100%",
                    backgroundColor: "transparent",
                }}
            >
                <PlanWrapper>
                    <PlanContainer>
                        <CloseBtn
                            onClick={(e) => {
                                e.preventDefault();
                                setOpen(false);
                            }}
                        >
                            <Close
                                style={{ color: "#fff", fontWeight: "bolder", fontSize: 25 }}
                            />
                        </CloseBtn>
                        <ButtonContainer
                            ref={backBtnRef}
                            disabled={currentPageIndex === 0}
                            onClick={(e) => {
                                e.preventDefault();
                                onPageChange("left");
                            }}
                            left={8}
                        >
                            <ArrowBackIos style={{ fontSize: "40px" }} />
                        </ButtonContainer>
                        <ButtonContainer
                            ref={forwardBtnRef}
                            disabled={currentPageIndex >= select_book_pages.length - 2}
                            onClick={() => {
                                onPageChange("right");
                            }}
                            right={0}
                        >
                            <ArrowForwardIos style={{ fontSize: "40px" }} />
                        </ButtonContainer>
                        <Container>
                            <PrintWrapper>
                                <Row style={{ width: "100%", height: "100%", maxWidth: "100%", padding: 0 }}>
                                    <Col lg={12} md={24} xl={12} xs={24} >
                                        <Images
                                            src={activePageResource}
                                        />
                                    </Col>
                                    <Col lg={12} md={24} xl={12} xs={24} >
                                    {/* ///THis ONe */}
                                        <AnswerWindow src={currentPageResourse} input_position={input_position} label_position={label_position} />
                                    </Col>
                                </Row>
                            </PrintWrapper>
                        </Container>
                    </PlanContainer>
                </PlanWrapper>
            </Modal>
        </SentryWrap>
    );
};

export default GraphicAssignmentPreview;